export default "__VITE_ASSET__BBDRx7qP__"